function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.439 10.9412c0-.5845-.4917-1.0588-1.0975-1.0588h-5.122c-2.223 0-4.0244-1.738-4.0244-3.8824 0-2.1445 1.8015-3.8824 4.0244-3.8824h5.8537C14.2946 2.1205 16.0946 3.857 16.0976 6v.7059c0 .5845.4917 1.0588 1.0975 1.0588.6059 0 1.0976-.4743 1.0976-1.0588V6c-.0044-3.312-2.7864-5.9958-6.2195-6H6.2195C2.785 0 0 2.6866 0 6s2.7849 6 6.2195 6h5.122c.6058 0 1.0975-.4744 1.0975-1.0588M23.7805 12h-5.8537c-3.4331-.0042-6.215-2.688-6.2195-6v-.7059c0-.5845.4917-1.0588 1.0976-1.0588.6058 0 1.0975.4743 1.0975 1.0588V6c.003 2.143 1.803 3.8795 4.0244 3.8824h5.8537c2.223 0 4.0244-1.738 4.0244-3.8824 0-2.1445-1.8015-3.8824-4.0244-3.8824h-5.122c-.6058 0-1.0975-.4743-1.0975-1.0588C17.561.4744 18.0527 0 18.6585 0h5.122C27.215 0 30 2.6866 30 6s-2.7849 6-6.2195 6",
  fill: "#C7D3E3",
  fillRule: "evenodd"
});

function SvgChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.9e989509.svg";
export { ForwardRef as ReactComponent };